module.exports = __webpack_public_path__ + "img/apollomunich.f53d0698.jpg";